import { KuxProgramPlaceholderType } from '@kaltura-ott/tvpil';
import { computed, observable } from 'mobx';
import { container } from 'tsyringe';

import type { LinearRepository } from '../linearRepository/linear-repository';

import type { Linear } from './Linear';

/**
 * ProgramPlaceholder are created automatically for EPG channels. After downloading programs, they are removed from channel
 */
export class ProgramPlaceholder {
  @observable.ref
  public data: KuxProgramPlaceholderType;

  @computed get linear(): Linear | undefined {
    const linearRepository = container.resolve<LinearRepository>('linearRepository');

    return linearRepository.getLinearById(this.data.linearAssetId);
  }

  public get id(): number {
    return this.data.id;
  }

  constructor(data: KuxProgramPlaceholderType) {
    this.data = data;
  }
}
